import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled,
} from '@mui/material'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ITenderProtocolData } from 'types/final-protocol'

const StyledTableCell = styled(TableCell)(() => ({
  padding: 0,
  width: '100%',

  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    borderRadius: 0,
  },

  '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled': {
    background: 'rgba(128,128,128, 0.1)',
  },
}))

type Props = {
  protocolData: ITenderProtocolData
}

export const CommercialEvaluationResultsTable = ({ protocolData }: Props) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields } = useFieldArray({
    control,
    name: `procurementEvaluationResults`,
  })

  return (
    <TableContainer>
      <Table
        sx={{
          tableLayout: 'fixed',
          background: '#FFF',
          '& td, th': {
            border: '1px solid #ccc',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>{t('ordinal')}</TableCell>
            <TableCell>{t('supplier-name')}</TableCell>
            <TableCell>{t('proposal-price')}</TableCell>
            <TableCell>{t('ship-costs')}</TableCell>
            <TableCell>{t('custom-costs')}</TableCell>
            <TableCell>{t('other-costs')}</TableCell>
            <TableCell>{t('vat-single')}</TableCell>
            <TableCell>{t('final-price-azn')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fields.map((commercialEva, index) => {
            return (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <StyledTableCell>
                  <Controller
                    name={`procurementEvaluationResults.${index}.orgName`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Controller
                    name={`procurementEvaluationResults.${index}.totalPriceSum`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Controller
                    name={`procurementEvaluationResults.${index}.deliveryCosts`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Controller
                    name={`procurementEvaluationResults.${index}.customCosts`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Controller
                    name={`procurementEvaluationResults.${index}.otherCosts`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Controller
                    name={`procurementEvaluationResults.${index}.vat`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Controller
                    name={`procurementEvaluationResults.${index}.finalPrice`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
